import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';
import { IBuilderStats } from '../../types/newbuilding/builder';
import { ArrowLink } from './ArrowLink';
import { Brief } from './Brief';
import { BuilderStats } from './BuilderStats';
import { Card } from './Card';
import { Logo } from './Logo';
import * as styles from './BuilderCard.css';

interface IBuilderCardProps {
  name?: string | null;
  logoUrl?: string | null;
  stats?: IBuilderStats | null;
  website?: string | null;
}

export function BuilderCard({ name, logoUrl, stats, website }: IBuilderCardProps): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <Card footer={website && <ArrowLink url={website}>Подробнее о застройщике</ArrowLink>}>
        <div className={styles['header']}>
          <Brief label="Застройщик" value={<UIText1 fontWeight="normal">{name}</UIText1>} />
          <Logo url={logoUrl} />
        </div>
        {stats && (
          <div className={styles['stats']}>
            <BuilderStats done={stats.done} inProgress={stats.inProgress} />
          </div>
        )}
      </Card>
    </div>
  );
}
